var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('v-app',[_c('Header',{attrs:{"onClickToggleDrawer":_vm.handleClickToggleDrawer}}),_c('DrawerCalendar'),_c('v-content',[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }